import { combineReducers } from "redux";
import generateDocumentViewerLinkAddLogReducer from "./documentViewerReducer";


const documentViewerReducer = combineReducers({
  documentViewer: generateDocumentViewerLinkAddLogReducer
});

export default documentViewerReducer;